export default "__VITE_ASSET__DxkrZHJn__"